// extracted by mini-css-extract-plugin
export default {"sliderBox":"RangeSlider_sliderBox__ggDYF","question":"RangeSlider_question__DgBuA"};